var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"jz-button-group",class:[
    _vm.data.class,
    _vm.data.staticClass,
    {
      'column-on-small-screen': _vm.props.isColumnOnSmallScreen
    }
  ],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }